module.exports = require('./build/ReactGridLayout');
module.exports.Responsive = require('./build/ResponsiveReactGridLayout');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-grid-layout/index.js
 ** module id = 1197
 ** module chunks = 0
 **/